import BasePolicy from '@/policies/BasePolicy.js';

export default class CoursePolicy extends BasePolicy {
    viewAny(user) {
        // Must match the backend CoursePolicy::viewAny and the /courses route
        // guard, which both require `view all courses` — gating menus on the
        // weaker `view a course` shows links the user cannot open.
        return user.hasPermissionTo('view all courses') || user.hasGroupPermissionTo('view all courses');
    }

    view(user, course) {
        return user.hasPermissionViaCourseTo(course, 'view a course');
    }

    viewReports(user, course) {
        return (
            user.hasPermissionViaCourseTo(course, 'view instructor discussions report') ||
            user.hasGroupPermissionTo(course, 'view instructor discussions report')
        );
    }

    viewCourseKeyEnabled(user, course) {
        return this.update(user, course) || user.isInstructorOf(course);
    }

    viewGlobalCourseDetails(user) {
        return user.is_admin || user.hasRole('Instructor');
    }

    create(user, groupIds) {
        if (!groupIds) {
            return user.hasPermissionTo('create a course');
        }

        return user.hasGroupPermissionTo('create a course');
    }

    update(user, course) {
        return (
            user.hasPermissionViaCourseTo(course, 'edit a course') ||
            user.hasGroupPermissionTo('edit a course') ||
            user.hasRoleWithinCourseGroup(course, 'Content Editor')
        );
    }

    delete(user, course) {
        return user.hasPermissionViaCourseTo(course, 'delete a course');
    }
}
